import React from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import useStyles from 'isomorphic-style-loader/useStyles';
import s from './OurServices.css';
import useScrollReveal from '../../hooks/useScrollReveal';
import messages from '../../../../locale/messages';

const services = [
  {
    id: 'food',
    title: messages.homeServiceFoodTitle,
    desc: messages.homeServiceFoodDesc,
    image: '/SiteImages/food.webp',
    icon: '🍔',
    bg: '#FFF4E5',
  },
  {
    id: 'ride',
    title: messages.homeServiceRideTitle,
    desc: messages.homeServiceRideDesc,
    image: '/SiteImages/ride.webp',
    icon: '🛵',
    bg: '#E8F5E9',
  },
  {
    id: 'grocery',
    title: messages.homeServiceGroceryTitle,
    desc: messages.homeServiceGroceryDesc,
    image: '/SiteImages/grocery.webp',
    icon: '🛒',
    bg: '#E3F2FD',
  },
];

function OurServices({ intl }) {
  useStyles(s);
  const { ref, isVisible } = useScrollReveal();

  return (
    <section id="services" className={s.services} ref={ref}>
      <div className={s.inner}>
        <p className={`${s.eyebrow} ${isVisible ? s.eyebrowVisible : ''}`}>
          <FormattedMessage {...messages.homeServicesEyebrow} />
        </p>
        <h2 className={`${s.title} ${isVisible ? s.titleVisible : ''}`}>
          <FormattedMessage {...messages.homeServicesTitle} />
        </h2>

        <div className={s.grid}>
          {services.map((svc, i) => (
            <div
              key={svc.id}
              className={`${s.card} ${isVisible ? s.cardVisible : ''}`}
              style={{ transitionDelay: isVisible ? `${0.2 + i * 0.12}s` : '0s' }}
            >
              <div className={s.imageWrap}>
                <img
                  src={svc.image}
                  alt={intl.formatMessage(svc.title)}
                  className={s.image}
                  onError={(e) => {
                    e.currentTarget.style.display = 'none';
                    e.currentTarget.nextSibling.style.display = 'flex';
                  }}
                />
                <span className={s.fallbackIcon} aria-label={intl.formatMessage(svc.title)}>
                  {svc.icon}
                </span>
              </div>
              <p className={s.cardTitle}>
                <FormattedMessage {...svc.title} />
              </p>
              <p className={s.cardDesc}>
                <FormattedMessage {...svc.desc} />
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default injectIntl(OurServices);
